import React, { useEffect, useRef } from "react";
import ManageUsers from "./ManageUsers";
import { BackgroundPage } from "./styles.addUserLookup";

// Decorative Manage Users list shown behind the add-user bottom sheets.
// Rendered as a non-fetching backdrop (isBackdrop) and marked `inert` so it is
// removed from the tab order and the accessibility tree — pointer-events:none
// alone blocks the mouse but not the keyboard.
const FlowBackdrop = () => {
  const backdropRef = useRef(null);

  useEffect(() => {
    if (backdropRef.current) backdropRef.current.inert = true;
  }, []);

  return (
    <BackgroundPage ref={backdropRef} aria-hidden="true">
      <ManageUsers isBackdrop />
    </BackgroundPage>
  );
};

export default FlowBackdrop;
